import { Component, OnInit, ViewChild, ViewEncapsulation, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { ApiService } from "app/shared/services/api.service";
import { environment } from "environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import swal from 'sweetalert2';
import { DynamicDetailComponent } from "../../dynamic-detail/dynamic-detail.component";
import { Subscription } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState } from "app/App Store/state";
import { setPageNumber } from "app/App Store/actions/pageChange.actions";

@Component({
  selector: 'app-student-pipelines-list',
  templateUrl:'./student-pipelines-list.component.html',
  styleUrls: ['./student-pipelines-list.component.scss',
    "../../../../../../assets/sass/libs/datatables.scss",],
encapsulation: ViewEncapsulation.None,
})
export class StudentPipelinesListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 20,
    totalPages:0
  };
  searchByName=''
  isActivated:boolean
  
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 20;
  selectedValue='';
  isFilter:boolean=false
  
  public columns = [
    { name: "Name", prop: "name" },
    { name: "Contact", prop: "phone" },
    { name: "Email", prop: "email" },
    { name: "Pipeline Stage", prop: "pipeline_stage" },
    { name: "Status", prop: "status" },
    { name: "Actions", prop: "Actions" },
  ];
  myDrop1: any;
  userId:any

  private tempData = [];
  imageUrl=environment.apiUrls.imageUrl;
  user_id:any;
  student_id:any;
  currentUrl:any
  resultPassword:any
  @ViewChild('name') inputName;
  user_role:any
  activeTab:any

  guideline_data:any
  pipeline_stages =[]
  selected_pipeline_stage = null
  row_id:any

  pipeline_model ={
    stage: '',
    notes: '',
  }
  row_name :any
  form_data = new FormData()
  pageNumberSubscription : Subscription
  pageNo

  // Import CSV properties
  import_model = {
    import_filename: '',
    collage_id: ''
  }
  selected_file: File = null
  selectedFileName: string = ''
  collegeList = []

  // Export CSV properties
  export_model = {
    status: '',
    import_filename: '',
    start_date: '',
    end_date: '',
    month: '',
    year: ''
  }
  statusList = []

  //matching properties
  selectedCollegeId: string = '';
  isMatching: boolean = false;
  matchResult: any = null;
  @ViewChild('resultModal') resultModal: any;

  constructor(private apiService:ApiService,
              private modalService: NgbModal,
              public toastr: ToastrService,
              private spinner: NgxSpinnerService,
              private activatedRoute:ActivatedRoute,
              private route: Router,
              private store: Store<AppState>,
              private cdr: ChangeDetectorRef
             ) {
    this.currentUrl=this.activatedRoute.snapshot.routeConfig.path
    this.user_role=JSON.parse(localStorage.getItem('user'))
    
    let setting_data = JSON.parse(localStorage.getItem('setting-record'))
    let key_data = setting_data.filter((item) => item.key == 'Student Pipelines') 
    this.guideline_data = key_data[0]?._id

    this.activatedRoute.queryParamMap.subscribe((params) => {
      let page = +params.get('page');
      this.setPage(page)
    });
    this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
    .subscribe(pageNumber => {
      this.page.pageNumber = pageNumber;
      if(pageNumber !==undefined){
        this.page.pageNumber = pageNumber -1
      }
      if(pageNumber === 0) this.page.pageNumber = 0
    });
  }
  
  ngOnInit(): void {
    this.getAllStudentPipelines()
    this.getPipelineStages()
    this.loadColleges()
    this.loadStatusList()
  }

  loadColleges(): void {
    this.apiService.getAllCollegeWithBusinessDetails().subscribe(
      (res: any) => {
        const items = res?.items || res?.data?.items || [];
  
        this.collegeList = items.map((college: any) => ({
          _id: String(college.businessid?._id), // or use businessid._id if required
          name: college.businessid?.name
        }));
      },
      (error) => {
        console.error('❌ Error loading colleges:', error);
        this.toastr.error('Failed to load colleges');
      }
    );
  }
  
  loadStatusList(): void {
    this.statusList = [
      { value: 'extracted', name: 'Extracted' },
      { value: 'moved to erp', name: 'Moved to ERP' }
    ];
  }
  
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  
  clearFilter(){
    this.searchByName = ''
    this.getAllStudentPipelines()
  }

  getFilterStudentPipeline(data?:any){ 
    this.searchByName = data 
    this.apiService.getStudentPipelineSearch(1, 100, this.searchByName).subscribe((res:any)=>{
      if(res.statusCode === 200){
        // Search API returns data as array directly, not in items
        this.rows = Array.isArray(res?.data) ? res.data : (res?.data?.items || []);
        this.page.totalPages = res?.data?.totalCount || (Array.isArray(res?.data) ? res.data.length : 0);
        this.page.pageNumber = 0;
        
        // Force change detection
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      }
      else{
        this.toastr.error(res.error)
      }
    })
  }

  resetFilter(){
    this.inputName.nativeElement.value = '';
    this.searchByName = '';
    this.getAllStudentPipelines()
  }

  getAllStudentPipelines(){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAllStudentPipelines(this.page.pageNumber+1,this.limitRef).subscribe((res:any)=>{
      this.spinner.hide();
      if(res.statusCode=== 200){
        this.rows = res?.data?.items || []
        this.page.totalPages = res?.data?.totalCount || 0
      }
      else{
        this.toastr.error(res.error)
      }
    })
  }

  pageChangeData(page:any) {
    this.route.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { page: page.offset +1 },
      queryParamsHandling: 'merge'
    });
    this.apiService.getAllStudentPipelines(page.offset +1,this.limitRef).subscribe((res:any)=>{
      this.setPage(page.offset +1)
      this.rows = res?.data?.items || []
      this.page.totalPages = res?.data?.totalCount || 0
    })
  }
  
  deleteStudentPipeline(password){
    if(this.student_id){
      this.apiService.deleteStudentPipeline(this.student_id,password).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.getAllStudentPipelines()
          swal.fire({
            title: 'Success',
            text: 'Student pipeline deleted successfully !',
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
        else{
          swal.fire({
            title: 'Cancelled',
            text: `${res.error}`,
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        } 
      })
    }
    else{
      this.toastr.error('Something went wrong !')
    }
  }

  ConfirmColor(id:any) {
    this.student_id=id  
    swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then( (result)=> {
      if (result.value) {  
        this.deleteStudentPipeline(result.value)
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }

  activateStudentPipeline(data){
    var id = data._id
    this.isActivated = data.is_activated = !data.is_activated
  
    let model={
      is_activated: this.isActivated
    }
    this.apiService.updateStudentPipeline(id,model).subscribe((res: any) => {
      if (res.isSuccess === true || res.statusCode === 200) {
        this.toastr.success(res.message || 'Updated successfully')
        this.getAllStudentPipelines()
      }
      else{
        this.toastr.error(res.error)
      }
    }) 
  }

  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg',
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }

  getPipelineStages() {
    this.apiService.getLeadsStatusList("pipelinestages").subscribe((res: any) => {
      this.pipeline_stages = res?.data
    })
  }

  openPipelineStageModal(content,id,pipelineStage) {
    this.row_id = id
    if(pipelineStage){
      this.selected_pipeline_stage = pipelineStage
    }
 
    const options: NgbModalOptions = {
      size: 'md',
      backdrop: 'static',
      centered: true
    };
    const modalRef = this.modalService.open(content,options);
    modalRef.result.then((result) => {
      this.selected_pipeline_stage = null
      this.row_id = null
    }, (reason) => {
      this.selected_pipeline_stage = null
      this.row_id = null
    });
  }

  pipelineStageUpdate(){
    let body={
      pipeline_stage : this.selected_pipeline_stage
    }
    this.apiService.updateStudentPipeline(this.row_id,body).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success('Pipeline stage updated successfully!')
        this.modalService.dismissAll()
        this.getAllStudentPipelines()
      }
      else this.toastr.error(res?.error)
    })
  }

  openMatchModal(content) {
    this.selectedCollegeId = '';
    this.matchResult = null;
    
    const options: NgbModalOptions = {
      size: 'lg',
      backdrop: 'static',
      centered: true
    };
    
    this.modalService.open(content, options).result.then(
      (result) => {
        // Modal closed
      },
      (reason) => {
        // Dismissed
      }
    );
  }

  openImportModal(content) {
    // Reset the form
    this.import_model = {
      import_filename: '',
      collage_id: ''
    }
    this.selected_file = null
    this.selectedFileName = ''

    const options: NgbModalOptions = {
      size: 'md',
      backdrop: 'static',
      centered: true
    };
    const modalRef = this.modalService.open(content, options);
    modalRef.result.then((result) => {
      this.resetImportForm()
    }, (reason) => {
      this.resetImportForm()
    });
  }

matchStudents() {
    if (this.isMatching) return;
    
    this.isMatching = true;
    
    this.apiService.matchAllStudentPipelineWithStudent(this.selectedCollegeId).subscribe(
        (res: any) => {
            this.isMatching = false;
            this.matchResult = res.data || res;
            this.toastr.success('Matching completed successfully!');
            this.modalService.dismissAll();
            localStorage.setItem('studentPipelineMatchResult', JSON.stringify(this.matchResult));
            this.route.navigate(['/student-pipelines/matching-results']);
            this.getAllStudentPipelines();
        },
        (error) => {
            this.isMatching = false;
            console.error('Error matching students:', error);
            this.toastr.error('Failed to match students. Please try again.');
        }
    );
}

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selected_file = file;
      this.selectedFileName = file.name;
      this.import_model.import_filename = file.name;
    }
  }

  isImportFormValid(): boolean {
    return this.selected_file !== null && 
           this.import_model.import_filename.trim() !== '' && 
           this.import_model.collage_id.trim() !== '';
  }

  submitImport() {
    if (!this.isImportFormValid()) {
      this.toastr.error('Please fill all required fields');
      return;
    }

    const formData = new FormData();
    formData.append('file', this.selected_file);

    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });

    this.apiService.importStudentPipelineCSV(
      formData,
      this.import_model.import_filename,
      this.import_model.collage_id
    ).subscribe((res: any) => {
      this.spinner.hide();
      if (res?.statusCode === 200 || res?.isSuccess === true) {
        this.toastr.success(res?.message || 'Student pipeline imported successfully!');
        this.modalService.dismissAll();
        this.getAllStudentPipelines();
      } else {
        this.toastr.error(res?.error || 'Failed to import student pipeline');
      }
    }, (error) => {
      this.spinner.hide();
      this.toastr.error('An error occurred while importing');
    });
  }

  resetImportForm() {
    this.import_model = {
      import_filename: '',
      collage_id: ''
    }
    this.selected_file = null;
    this.selectedFileName = '';
  }

  openExportModal(content) {
    // Reset the form
    this.export_model = {
      status: '',
      import_filename: '',
      start_date: '',
      end_date: '',
      month: '',
      year: ''
    }

    const options: NgbModalOptions = {
      size: 'md',
      backdrop: 'static',
      centered: true
    };
    const modalRef = this.modalService.open(content, options);
    modalRef.result.then((result) => {
      this.resetExportForm()
    }, (reason) => {
      this.resetExportForm()
    });
  }

  submitExport() {
    // Build query parameters
    const params: any = {};

    if (this.export_model.status) params.status = this.export_model.status;
    if (this.export_model.import_filename) params.import_filename = this.export_model.import_filename;
    if (this.export_model.start_date) params.start_date = this.export_model.start_date;
    if (this.export_model.end_date) params.end_date = this.export_model.end_date;
    if (this.export_model.month) params.month = this.export_model.month;
    if (this.export_model.year) params.year = this.export_model.year;

    // Get the export URL and open it in a new tab
    const exportUrl = this.apiService.exportStudentPipelinesCSV(params);
    window.open(exportUrl, '_blank');

    this.toastr.success('Export initiated! The CSV file will download in the new tab.');
    this.modalService.dismissAll();
  }

  resetExportForm() {
    this.export_model = {
      status: '',
      import_filename: '',
      start_date: '',
      end_date: '',
      month: '',
      year: ''
    }
  }

  matchStudentPipeline(pipelineId: string) {
    if (!pipelineId) {
      this.toastr.error('Invalid pipeline id');
      return;
    }

    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });

    this.apiService.matchStudentPipelineWithStudent(pipelineId).subscribe((res: any) => {
      this.spinner.hide();
      if ((res?.statusCode === 200 || res?.isSuccess === true) && res?.MatchedStudent) {
        const comparisonHtml = this.buildComparisonHtml(res?.MatchedStudent, res?.MatchingPipeline);

        const matchedStudentId = res?.MatchedStudent?._id;
        const matchedPipelineId = res?.MatchingPipeline?._id || pipelineId;

        swal.fire({
          title: 'Matched Student',
          html: comparisonHtml,
          width: '900px',
          icon: 'success',
          showCancelButton: true,
          confirmButtonText: 'Confirm Merge',
          cancelButtonText: 'Close',
          customClass: {
            confirmButton: 'btn btn-success',
            popup: 'match-comparison-modal'
          }
        }).then(result => {
          if (result.isConfirmed) {
            this.confirmStudentPipelineMerge(matchedPipelineId, matchedStudentId);
          }
        });
      } else {
        swal.fire({
          title: 'No match found',
          text: res?.error || 'No matching student found for the given pipeline',
          icon: 'info',
          customClass: {
            confirmButton: 'btn btn-primary'
          }
        });
      }
    }, (error) => {
      this.spinner.hide();
      this.toastr.error(error?.error?.error || 'Unable to match student pipeline right now');
    });
  }

  confirmStudentPipelineMerge(pipelineId: string, studentId: string) {
    if (!pipelineId || !studentId) {
      this.toastr.error('Missing pipeline or student id for merge');
      return;
    }

    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });

    this.apiService.confirmStudentPipelineMerge(pipelineId, studentId).subscribe((res: any) => {
      this.spinner.hide();
      if (res?.statusCode === 200 || res?.isSuccess === true) {
        this.toastr.success(res?.message || 'Student and pipeline merged successfully');
        this.getAllStudentPipelines();
      } else {
        this.toastr.error(res?.error || 'Failed to confirm merge');
      }
    }, (error) => {
      this.spinner.hide();
      this.toastr.error(error?.error?.error || 'Unable to confirm merge right now');
    });
  }

  private buildComparisonHtml(student: any, pipeline: any): string {
    const studentInfo = student?.user || student || {};

    const studentSummary = this.renderSummaryCard({
      title: 'Student',
      name: studentInfo?.name,
      subtitle: studentInfo?.email,
      status: studentInfo?.status || student?.status,
      badge: studentInfo?.roles,
      phone: studentInfo?.phone || student?.phone,
      notes: student?.notes
    });

    const pipelineSummary = this.renderSummaryCard({
      title: 'Pipeline',
      name: pipeline?.name,
      subtitle: pipeline?.email,
      status: pipeline?.status,
      badge: pipeline?.interested_in,
      phone: pipeline?.phone,
      notes: pipeline?.notes
    });

    return `
      <div class="match-comparison-popup">
        <div class="comparison-header">
          ${studentSummary}
          <div class="match-chip">
            <span class="match-chip__icon">⇄</span>
          </div>
          ${pipelineSummary}
        </div>
       
      </div>
    `;
  }

  private getValue(value: any): string {
    if (value === null || value === undefined || value === '' || value === 'undefined') {
      return 'NA';
    }
    if (Array.isArray(value) && value.length === 0) {
      return 'NA';
    }
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    return value;
  }


  private renderSummaryCard(config: {
    title: string;
    name: string;
    subtitle: string;
    status: string;
    badge: string;
    phone: string;
    notes: string;
  }): string {
    return `
      <div class="summary-card">
        <div class="summary-title">${config.title}</div>
        <div class="summary-name">${this.getValue(config.name)}</div>
        <div class="summary-subtitle">${this.getValue(config.subtitle)}</div>
        <div class="summary-meta">
          <span class="chip chip-status">${this.getValue(config.status)}</span>
          <span class="chip chip-badge">${this.getValue(config.badge)}</span>
        </div>
        <div class="summary-extra">
          <div><strong>Phone:</strong> ${this.getValue(config.phone)}</div>
          <div><strong>Notes:</strong> ${this.getValue(config.notes)}</div>
        </div>
      </div>
    `;
  }
}

